// extracted by mini-css-extract-plugin
module.exports = {"farm":"Farm_farm__3_LIw"};